import { useStore } from "../store";
import { DraggableOverlay } from "../util/DraggableOverlay";
import { useIsTouch } from "../util/useIsTouch";
import { useVoiceStore } from "./store";

/**
 * Small HUD panel listing players currently in LiveKit's ActiveSpeakers
 * set. Mounted alongside MicHud; gives a "who is talking" cue even when
 * the speaker is off-screen.
 */
export function SpeakerList(): JSX.Element | null {
  const activeSpeakers = useVoiceStore((s) => s.activeSpeakers);
  const tokenInfo = useVoiceStore((s) => s.tokenInfo);
  const remotePlayers = useStore((s) => s.remotePlayers);
  const localPlayer = useStore((s) => s.localPlayer);
  const isTouch = useIsTouch();

  if (!tokenInfo) return null;
  if (activeSpeakers.size === 0) return null;

  const names: string[] = [];
  activeSpeakers.forEach((identity) => {
    if (localPlayer && identity === localPlayer.id) {
      names.push("You");
    } else {
      const p = remotePlayers.get(identity);
      names.push(p?.displayName || identity.slice(0, 6));
    }
  });

  return (
    <DraggableOverlay
      id="voice-speakers"
      // Stacks below MicHud (top:60, ~140px tall with settings closed; ~280px
      // with settings popover open — top:220 leaves clearance for the closed
      // state and the popover is short-lived so the small overlap is OK).
      defaultAnchor={{ right: 12, top: 220, safeAreaTop: isTouch }}
      enabled={isTouch}
      zIndex={15}
    >
      <div
        style={{
          padding: "6px 10px",
          background: "rgba(15,16,24,0.86)",
          border: "1px solid #2a2a36",
          borderRadius: 6,
          color: "#e8e8ef",
          fontSize: 12,
          maxWidth: 220,
          pointerEvents: "none",
        }}
      >
        <div style={{ color: "#7df0a8", fontWeight: 600, fontSize: 11, marginBottom: 2 }}>
          SPEAKING
        </div>
        {names.map((n, i) => (
          <div key={i}>{n}</div>
        ))}
      </div>
    </DraggableOverlay>
  );
}
